import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
import { Types, IConsultarRelatorioMensalDareRequest } from './types';
import {
	consultarRelatorioMensalDareFailure,
	consultarRelatorioMensalDareSuccess,
} from './actions';

function* consultarRelatorioMensalDare(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: IConsultarRelatorioMensalDareRequest } =
		request;

	// yield put(consultarRelatorioMensalDareClear());
	let body = { ...payload };

	delete body.current;

	body = cleanEmpty(body) as IConsultarRelatorioMensalDareRequest;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`estatisticas/relatorio-dare`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultarRelatorioMensalDareSuccess(response));
	} else {
		yield put(consultarRelatorioMensalDareFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTAR_RELATORIO_MENSAL_DARE_REQUEST,
		consultarRelatorioMensalDare,
	),
]);
